import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link, useNavigate } from "react-router-dom";
import { Check, ShoppingBag, ArrowRight } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function Packages() {
  const [pkgs, setPkgs] = useState([]);
  const navigate = useNavigate();
  const { add } = useCart();
  useEffect(() => { api.get("/packages").then((r) => setPkgs(r.data)); }, []);
  return (
    <div className="pt-32 pb-24 container-x" data-testid="packages-page">
      <div className="max-w-3xl mb-16">
        <div className="kicker mb-3">Curated Systems</div>
        <h1 className="font-display text-5xl md:text-7xl">Home Theatre <em className="not-italic gold-text">Packages.</em></h1>
        <p className="mt-6 text-white/60 max-w-xl leading-relaxed">Every package is professionally installed, calibrated with reference tools and backed by full manufacturer warranty.</p>
      </div>
      <div className="space-y-10">
        {pkgs.map((p, idx) => (
          <div key={p.id} className={`card-luxury overflow-hidden grid md:grid-cols-2 gap-0 ${idx % 2 === 1 ? "md:[direction:rtl]" : ""}`} data-testid={`package-detail-${p.id}`}>
            <div className="aspect-[4/3] overflow-hidden md:[direction:ltr]">
              <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
            </div>
            <div className="p-10 md:p-14 flex flex-col justify-center md:[direction:ltr]">
              <span className="kicker mb-3">{p.tier}</span>
              <h2 className="font-display text-3xl md:text-4xl">{p.name}</h2>
              <p className="mt-4 text-white/60">{p.description}</p>
              <ul className="mt-6 space-y-2.5">
                {p.highlights.map((h, i) => (
                  <li key={i} className="flex gap-3 text-sm text-white/80"><Check className="w-4 h-4 text-gold mt-0.5" />{h}</li>
                ))}
              </ul>
              <div className="mt-8 flex items-center justify-between gap-4 flex-wrap">
                {p.consultation_only ? (
                  <div className="text-gold font-medium">Consultation Required</div>
                ) : (
                  <div className="text-3xl font-display">₹{p.price?.toLocaleString('en-IN')}</div>
                )}
                {p.consultation_only ? (
                  <Link to="/consultation" className="btn-gold text-xs px-6 py-3">Book Appointment <ArrowRight className="w-3.5 h-3.5" /></Link>
                ) : (
                  <div className="flex gap-2">
                    <button onClick={() => add(p)} className="btn-ghost-outline text-xs px-5 py-3" data-testid={`pkg-detail-add-${p.id}`}>
                      <ShoppingBag className="w-3.5 h-3.5" /> Add to Cart
                    </button>
                    <button onClick={() => { add(p); navigate("/cart"); }} className="btn-gold text-xs px-6 py-3" data-testid={`pkg-detail-buy-${p.id}`}>
                      Buy Now <ArrowRight className="w-3.5 h-3.5" />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
